import React, {Component} from 'react';
import Style from 'style-it'
import { styles } from './styles';

export class AddEventResultsButton extends Component {
  render() {
    const {
      message,
      isMobile,
      callback,
      t
    } = this.props;

    return (
        <div id='add-missing-results' style={{
          display: isMobile ? 'none' : 'flex',
          justifyContent: 'center',
          alignItems: isMobile ? 'center' : 'left',
          flexDirection: 'column'}}>
        <div style={styles.missingResults.header}>
          {t('Are we missing results?')}
        </div>
        <div style={styles.missingResults.body}>
          {t('Let us know and we\'ll get them added.')}
        </div>

        <div>
          <Style>
            {
              styles.addResultsHover()
            }
            <button
              className="hover-add-results-button"
              style={styles.addResultsButton(isMobile)}
              onClick={callback}>
                {message || t('ADD MISSING RESULTS')}
            </button>
          </Style>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./components/shared/AddEventResultsButton.js
 **/